export const PRIVACY_POLICY = 'privacyPolicy';
export const TERMS_AND_CONDITION = 'termsAndCondition';
export const SOFT_SKILLS_LIST = [
    {
        name: 'Confidence',
        type: 'soft',
    },
    {
        name: 'Communication',
        type: 'soft',
    },
    {
        name: 'Pressure Handling',
        type: 'soft',
    },
    {
        name: 'Approach & Attitude',
        type: 'analytics',
    },
    {
        name: 'Problem Solving',
        type: 'analytics',
    },
    {
        name: 'Result Oriented',
        type: 'analytics',
    },
    {
        name: 'Decision Making',
        type: 'leadership',
    },
    {
        name: 'Team Management',
        type: 'leadership',
    },
    {
        name: 'Accountability',
        type: 'leadership',
    },
];

export const SOFT_SKILLS_LIST_WITHOUT_LEADERSHIP = [
    {
        name: 'Confidence',
        type: 'soft',
    },
    {
        name: 'Communication',
        type: 'soft',
    },
    {
        name: 'Pressure Handling',
        type: 'soft',
    },
    {
        name: 'Approach & Attitude',
        type: 'analytics',
    },
    {
        name: 'Problem Solving',
        type: 'analytics',
    },
    {
        name: 'Result Oriented',
        type: 'analytics',
    },
];

export const GENERAL_ERROR = 'Something went wrong';

export const FACE_DETECTED = {
    DEFAULT: 'default',
    DETECTED: 'Face detected',
    NOT_DETECTED: 'Face not detected',
};

export const VIDEO_ID = 'preview_tile';

export const FACE_DETECTION_TEXTS = {
    ORANGE_TEXTS: [
        'The lighting is too dim. Please move to a brighter area',
        'The lighting is too bright. Adjust your position or lighting',
        'Keep your face centered within the oval',
        'Ensure your face stays completely inside the oval',
        'Please keep your face straight and centered',
    ],
    RED_TEXTS: ['Please ensure your face is visible in the frame', 'Multiple faces are present in the frame'],
};
